<template>
  <div
    v-if="visible && !modalOpen"
    class="cookie-notice"
    role="status"
    aria-live="polite"
  >
    <p>
      By continuing to browse Viberary, you agree to our use of analytics and
      advertising cookies as described in our
      <router-link to="/privacy-policy">Privacy Policy</router-link>
      and
      <router-link to="/terms-of-use">Terms of Use</router-link>.
    </p>
    <button type="button" class="cookie-notice__button" @click="accept">
      Accept
    </button>
  </div>
</template>

<script>
import {
  getCookieNoticeAcknowledged,
  setCookieNoticeAcknowledged
} from '../../analytics/viberaryGa4';

export default {
  name: 'AnalyticsConsent',
  data() {
    return {
      visible: false,
      modalOpen: false,
      modalObserver: null
    };
  },
  mounted() {
    this.visible = !getCookieNoticeAcknowledged();
    this.syncModalState();
    this.modalObserver = new MutationObserver(this.syncModalState);
    if (document.body) {
      this.modalObserver.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    window.addEventListener('viberary:open-cookie-notice', this.open);
    window.addEventListener('viberary:cookie-notice', this.sync);
  },
  beforeDestroy() {
    if (this.modalObserver) {
      this.modalObserver.disconnect();
    }
    window.removeEventListener('viberary:open-cookie-notice', this.open);
    window.removeEventListener('viberary:cookie-notice', this.sync);
  },
  methods: {
    syncModalState() {
      this.modalOpen = !!document.querySelector('.modal:not(.hidden)');
    },
    open() {
      this.visible = true;
    },
    sync() {
      this.visible = !getCookieNoticeAcknowledged();
    },
    accept() {
      setCookieNoticeAcknowledged();
    }
  }
};
</script>

<style scoped>
.cookie-notice {
  align-items: center;
  background: rgba(16, 16, 16, 0.98);
  border-top: 1px solid rgba(255,255,255,0.08);
  bottom: 0;
  box-shadow: 0 -8px 24px rgba(0,0,0,0.18);
  color: #f0f0f0;
  display: flex;
  gap: 12px;
  justify-content: center;
  left: 0;
  padding: 8px 16px;
  position: fixed;
  right: 0;
  z-index: 9000;
}
.cookie-notice p {
  font-size: 12px;
  line-height: 1.3;
  margin: 0;
  max-width: none;
  white-space: nowrap;
}
.cookie-notice a {
  color: #ffd300;
  text-decoration: none;
}
.cookie-notice a:hover,
.cookie-notice a:focus {
  text-decoration: underline;
}
.cookie-notice__button {
  background: #ffd300;
  border: 0;
  border-radius: 4px;
  color: #111;
  cursor: pointer;
  flex: 0 0 auto;
  font-weight: 700;
  padding: 7px 13px;
}
@media (max-width: 900px) {
  .cookie-notice p {
    white-space: normal;
  }
}
@media (max-width: 700px) {
  .cookie-notice {
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 14px;
  }
}
</style>
